import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as Cookies from "universal-cookie";
import { Dispatch, connect } from 'react-redux';
import { IReportState, ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IComparisonConversionResponse, IBasicCenterListResponse, IAppState } from '@nkr/store/index';
import { ISortBy, ICenterBase, ICenter, IComparisonConversion, IComparisonConversionTotals } from '@nkr/models/index';
import { IConversionPayload } from './conversion-payload';
import { DropdownButton, MenuItem, Alert } from 'react-bootstrap';
import ComparisonConversionFilter from './comparison-conversion-filter';
import CompareNav from './nav';
import Grid from './grid';
import { ColumnApi, ColumnWidthCallbackParams, ExcelExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { OrganType } from '@nkr/enums/organ-type';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
    centerList: ICenter[],
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getComparisonConversion: (donationYear: string, minReferrals: string, includeNkr: boolean, includeDash: boolean, centerType: string, donationType: number, isMicrosite: number) => Promise<IComparisonConversionResponse>,
    getComparisonConversionExport: (donationYear: string, minReferrals: string, includeNkr: boolean, includeDash: boolean, centerType: string, donationType: number, isMicrosite: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    report: IComparisonConversion[],
    reportGrandTotals: IComparisonConversionTotals[]
    isAnnualized: boolean,
    previousYear: number,
    currentYear: number
    conversionPayload: IConversionPayload,
    sortBy: ISortBy[],
    centerList: ICenterBase[],
    donationYearList: string[],
    gridApi: GridApi,
    columnApi: ColumnApi
}

class ComparisonConversionReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        report: [],
        reportGrandTotals: [],
        isAnnualized: false,
        previousYear: moment().get('year') - 1,
        currentYear: moment().get('year'),
        conversionPayload: {
            donationYear: moment().month() < 3 ? (moment().year() - 1).toString() : moment().year().toString(),
            includeDash: false,
            includeNkr: true,
            minReferrals: '0',
            centerType: '',
            organType: 1,
            isMicrosite: -1
        },
        sortBy: [],
        centerList: [],
        donationYearList: _.range(2017, moment().year() + 1, 1).reverse().map(year => year.toString()),
        gridApi: null,
        columnApi: null
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api,
            columnApi: e.columnApi
        });
    }

    componentDidMount = () => {
        this.getData();
    }

    isLiverCenterView = () =>  this.props.app.site.organType == OrganType.Liver;

    getData = () => {
        let newType = this.props.app.site.organType == OrganType.Kidney ? 1 : 2;
        let defaultCenterType = this.isLiverCenterView() ? '' : 'dcn';
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI("organType=" + newType + "&sites=nkr&centerType=" + defaultCenterType), { arrayFormat: 'bracket' });
        let cookies = new Cookies();

        let organTypeFromCookie = cookies.get('organType');

        if (organTypeFromCookie == null) {
            let current = new Date();
            let nextYear = new Date();

            nextYear.setFullYear(current.getFullYear() + 1);

            cookies.set("organType", newType, { path: "/", expires: nextYear, domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });

            organTypeFromCookie = newType;
        }

        let organTypeForPayload = organTypeFromCookie;

        if (parsed.organType != null) {
            organTypeForPayload = parsed.organType;
        }

        let conversionPayload: IConversionPayload = {
            donationYear: parsed.year != null ? parsed.year : moment().month() < 3 ? (moment().year() - 1).toString() : moment().year().toString(),
            includeDash: parsed.sites != null ? parsed.sites.indexOf('dash') >= 0 : false,
            includeNkr: parsed.sites != null ? parsed.sites.indexOf('nkr') >= 0 : true,
            minReferrals: parsed.min != null ? parsed.min : '0',
            centerType: parsed.centerType != null ? parsed.centerType : '',
            organType: organTypeForPayload,
            isMicrosite: parsed.isMicrosite != null ? parseInt(parsed.isMicrosite) : -1
        };

        let { donationYear, minReferrals, includeNkr, includeDash, centerType, organType, isMicrosite } = conversionPayload;

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            Promise.all([
                this.props.getComparisonConversion(donationYear, minReferrals, includeNkr, includeDash, centerType, organType, isMicrosite),
                this.props.getBasicCenterList()
            ])
                .then(([comparisonConversionResponse, centerListResponse]) => {
                    let { reportResults, grandTotalResults, currentYear, previousYear, isAnnualized } = comparisonConversionResponse.data.results;

                    let report = reportResults.map(x => ({ ...x, selected: false }));

                    this.setState({
                        report,
                        reportGrandTotals: grandTotalResults,
                        isAnnualized,
                        centerList: centerListResponse.data.results,
                        previousYear,
                        currentYear,
                        conversionPayload
                    }, () => {
                        this.setConversionUrl();
                        this.props.hideLoading();
                    });
                }).catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleFilter = (donationYear: string, minReferrals: string, includeNkr: boolean, includeDash: boolean, centerType: string, isMicrosite: number) => {
        let { organType } = this.state.conversionPayload;

        let conversionPayload: IConversionPayload = {
            donationYear,
            includeDash,
            includeNkr,
            minReferrals,
            centerType,
            organType,
            isMicrosite
        };

        this.props.showLoading("Searching, one moment please...").then(() => {
            this.props.getComparisonConversion(donationYear, minReferrals, includeNkr, includeDash, centerType, organType, isMicrosite).then(response => {
                if (response.data.success) {
                    let { reportResults, grandTotalResults, currentYear, previousYear, isAnnualized } = response.data.results;

                    this.setState({
                        report: reportResults,
                        reportGrandTotals: grandTotalResults,
                        isAnnualized,
                        currentYear,
                        previousYear,
                        conversionPayload
                    }, () => {
                        this.setConversionUrl();
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        })
    }

    handleOrganFilter = (organType: number) => {
        let conversionPayload = _.cloneDeep(this.state.conversionPayload);

        conversionPayload.organType = organType;

        this.setState({
            conversionPayload
        }, () => {
            let cookies = new Cookies();

            let { donationYear, minReferrals, includeNkr, includeDash, centerType, isMicrosite } = this.state.conversionPayload;

            this.props.showLoading("Searching, one moment please...").then(() => {
                this.props.getComparisonConversion(donationYear, minReferrals, includeNkr, includeDash, centerType, organType, isMicrosite).then(response => {
                    if (response.data.success) {
                        cookies.set("dashview", response.data.results.donationType, { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });

                        let { reportResults, grandTotalResults, currentYear, previousYear, isAnnualized } = response.data.results;

                        this.setState({
                            report: reportResults,
                            reportGrandTotals: grandTotalResults,
                            isAnnualized,
                            currentYear,
                            previousYear
                        }, () => {
                            this.setConversionUrl();
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                });
            });
        });
    }

    handleExport = () => {
        var columnKeys = this.state.columnApi.getAllColumns().filter(x => x.isVisible()).map(x => x.getColId()).filter(colId => colId != 'rank');

        let params: ExcelExportParams = {
            columnGroups: true,
            fileName: 'comparison-conversion.xlsx',
            columnKeys,
            columnWidth: (params: ColumnWidthCallbackParams) => {
                let colDef = params.column.getColDef();
                return colDef.width;
            },
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colId = params.column.getColId();

                if (params.node.isRowPinned() == false) {
                    let yesNo = ['isDcnCenter', 'isVoucherParticipant', 'isDsdCenter', 'hasFollowUp', 'isPlDashCenter', 'isMicrositeCenter', 'isInReferralNetwork', 'isDonorConnectEnabled']

                    if (yesNo.indexOf(colId) >= 0) {
                        return params.value ? 'Yes' : 'No';
                    }
                } else {
                    let data = params.node.data as IComparisonConversionTotals;

                    let totalsMap = {
                        'isDcnCenter': 'donorCareNetworkCount',
                        'isVoucherParticipant': 'voucherProgramCount',
                        'isDsdCenter': 'donorShieldDirectCount',
                        'hasFollowUp': 'followUpEnabledCount',
                        'isPlDashCenter': 'plDashCenterCount',
                        'isMicrositeCenter': 'micrositeCenterCount',
                        'isInReferralNetwork': 'nkrReferralNetworkCount',
                        'isDonorConnectEnabled': 'donorConnectEnabledCount',

                        'priorYearRegistrations': 'priorYearRegistrationsCount',
                        'priorYearReferrals': 'priorYearReferralsCount',

                        'reportYearRegistrations': 'reportYearRegistrationsCount',
                        'reportYearReferrals': 'reportYearReferralsCount',
                        'reportYearDonations': 'reportYearDonationsCount',
                        'donatedCountAnnualized': 'donatedCountAnnualizedCount',

                        'referredCountAverage': 'referredCountAverageCount',
                        'referralConversionRatePercent': 'referralConversionRatePercent',

                        'registeredCountAverage': 'registeredCountAverageCount',
                        'registrationConversionRatePercent': 'registeredConversionRatePercent',

                        'donatedNkrCount': 'nkrDonationsCount',
                        'nkrDonationPercent': 'nkrConversionRatePercent',

                        'donatedDirectCount': 'directDonatedCount',
                        'directDonationPercent': 'directDonatedConversionRatePercent',

                        'donatedDisconnectCount': 'disconnectCount',
                        'disconnectPercent': 'disconnectConversionRatePercent',

                        'contactTimeDaysMedianPriorYear': 'priorYearMedian',
                        'contactTimeDaysMedian': 'reportYearMedian'
                    }

                    let t = totalsMap[colId];

                    if (t != null) {
                        return data[t];
                    }
                }

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsExcel(params);
    }

    setConversionUrl = () => {
        let { includeDash, includeNkr, donationYear, centerType, minReferrals, organType, isMicrosite } = this.state.conversionPayload;
        let paramList = [];

        if (includeDash) {
            paramList.push(encodeURI('sites[]=dash'));
        }

        if (includeNkr) {
            paramList.push(encodeURI('sites[]=nkr'));
        }

        if (donationYear != '') {
            paramList.push(encodeURI('year=' + donationYear));
        }

        if (centerType != '') {
            paramList.push(encodeURI('centerType=' + centerType));
        }

        if (minReferrals != '') {
            paramList.push(encodeURI('min=' + minReferrals));
        }

        if (organType != null) {
            paramList.push(encodeURI('organType=' + organType));
        }

        if (isMicrosite != null) {
            paramList.push(encodeURI('isMicrosite=' + isMicrosite));
        }

        let params = paramList.join('&');

        let newUrl = this.props.isAdmin == false ?
            '/center/' + this.props.centerId + '/reports/dash-board/compare-conversion?' + params
            :
            '/admin/reports/dash-board/compare-conversion?' + params
            ;

        window.history.pushState({}, '', newUrl);
    }

    getOrganTypeTitle = () => {
        if (this.state.conversionPayload.organType == 1) {
            return 'Kidney Only';
        }

        if (this.state.conversionPayload.organType == 2) {
            return 'Liver Only';
        }

        if (this.state.conversionPayload.organType == 3) {
            return 'Liver & Kidney';
        }
    }

    render = () => {
        const organTypeTitle = this.getOrganTypeTitle();

        console.log(this.isLiverCenterView())

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                        <div>
                            <CompareNav activeKey='CONVERSION' centerId={this.props.centerId} isAdmin={this.props.isAdmin} />
                        </div>

                        {this.props.app.site.organType != OrganType.Liver && (
                            <div>View:&nbsp;
                                <DropdownButton bsStyle='primary' pullRight title={organTypeTitle} id='organType'>
                                    <MenuItem onClick={() => this.handleOrganFilter(2)}>Liver Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(1)}>Kidney Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(3)}>Liver &amp; Kidney Candidates</MenuItem>
                                </DropdownButton>
                            </div>
                        )}
                    </div>

                    <ComparisonConversionFilter
                        isAdmin={this.props.isAdmin}
                        isLiverCenterView={this.isLiverCenterView()}
                        centerId={this.props.centerId}
                        donationYear={this.state.conversionPayload.donationYear}
                        centerType={this.state.conversionPayload.centerType}
                        minReferrals={this.state.conversionPayload.minReferrals}
                        includeDash={this.state.conversionPayload.includeDash}
                        includeNkr={this.state.conversionPayload.includeNkr}
                        isMicrosite={this.state.conversionPayload.isMicrosite}
                        centerList={this.state.centerList}
                        donationYearList={this.state.donationYearList}
                        onFilter={this.handleFilter}
                        onExport={this.handleExport}
                    />

                    <div style={{ width: '100%' }}>
                        <Grid
                            data={this.state.report}
                            previousYear={this.state.previousYear}
                            currentYear={this.state.currentYear}
                            isAdmin={this.props.isAdmin}
                            isLiverCenterView={this.isLiverCenterView()}
                            centerId={this.props.centerId}
                            organType={this.state.conversionPayload.organType}
                            isMicrosite={this.state.conversionPayload.isMicrosite}
                            includeDash={this.state.conversionPayload.includeDash}
                            includeNkr={this.state.conversionPayload.includeNkr}
                            isAnnualized={this.state.isAnnualized}
                            totals={this.state.reportGrandTotals}
                            onGridReady={this.onGridReady}
                        />
                        <div className="row">
                            <div className="col-xs-12">
                                <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5, marginBottom: 0 }}>
                                    <p>**About 50% of donations donate the year they were referred and the other 50% donate the following year. So, we average referrals for the donation year and the year prior to calculate conversion rate.</p>
                                </Alert>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        reports: appState.reports,
        centerList: appState.centers.list,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getComparisonConversion: (donationYear, minReferrals, includeNkr, includeDash, centerType, donationType, isMicrosite) => {
            return dispatch(ReportActionCreators.getComparisonConversion(donationYear, minReferrals, includeNkr, includeDash, centerType, donationType, isMicrosite));
        },
        getComparisonConversionExport: (donationYear, minReferrals, includeNkr, includeDash, centerType, donationType, isMicrosite) => {
            return dispatch(ReportActionCreators.getComparisonConversionExport(donationYear, minReferrals, includeNkr, includeDash, centerType, donationType, isMicrosite))
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(ComparisonConversionReport);